import "./PopOver.scss";

import React, { useState } from "react";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";
import Button from "ui/build/components/Button/Button";
import Para from "ui/build/components/Para/Para";

import Prompt from "../../../utils/Prompt";
import { t } from "../../../utils/ResourceUtils";
import getRuntimeConfig from "../../../utils/runtimeConfig";
import RenderIcon from "../RheaSideNav/Icons/RenderIcon";
import { logoutAsync } from "./EditUserProfile/EditUserProfile.service";
import {
  autoLogout,
  checkingDataToShowPrompt,
  closePromptDialog,
  handleLogout,
  promptModalSubmit,
  triggerPopOver,
} from "./PopOver.utils";
import useAutoLogout from "./useAutoLogout";

const init = {
  heading: t("cm.confirmation"),
  submitText: t("cm.proceed"),
  cancelText: t("cm.cancel"),
  contentText: t("cm.do_you_want_to_proceed"),
  onSubmit: "",
  onCancel: "",
  size: "md",
};

const PopOver = (props) => {
  const { openEditProfile } = props;
  const [showPopOver, setshowPopOver] = useState(false);
  const [confirmDialogOptions, setConfirmDialogOptions] = useState(init);
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const timer = useAutoLogout(parseInt(getRuntimeConfig()?.idleSessionUserInactivityTimer));
  const loggedMail = JSON.parse(localStorage.getItem("loginResponse"))?.object?.username;
  const loggedUser = JSON.parse(localStorage.getItem("loginResponse"))?.object?.name;

  autoLogout({ timer, logoutAsync });

  return (
    <React.Fragment>
      {["bottom"].map((placement) => (
        <OverlayTrigger
          trigger="click"
          onToggle={() => triggerPopOver({ showPopOver, setshowPopOver })}
          show={showPopOver}
          key={placement}
          rootClose
          placement={placement}
          overlay={
            <Popover id={`popover-positioned-${placement}`}>
              <Popover.Content>
                <div className="d-flex justify-content-between">
                  <div className="image-container">
                    <div className="image-centerer">
                      <img src="/assets/Default.png" alt="image" />
                    </div>
                  </div>
                  <div className="profile-details">
                    <p className="name">{loggedUser}</p>
                    <p className="mail">{loggedMail}</p>
                    <div className="edit-profile">
                      <Button
                        onClick={() => {
                          setshowPopOver(false);
                          openEditProfile();
                        }}
                        className="btn edit-btn"
                        varient="primary"
                      >
                        {t("cm.edit_profile")}
                      </Button>
                    </div>
                  </div>
                </div>
                <div className="line"></div>
                <div style={{ paddingLeft: "11px", paddingTop: "5px" }}>
                  <Para
                    onClick={() =>
                      checkingDataToShowPrompt({
                        setConfirmDialogOptions,
                        promptModalSubmit: () => promptModalSubmit({ setShowConfirmDialog, handleLogout }),
                        closePromptDialog: () => closePromptDialog({ setShowConfirmDialog }),
                        setShowConfirmDialog,
                      })
                    }
                  >
                    <RenderIcon icon="RiLogoutBoxRLine" /> &nbsp; {t("cm.logout")}
                  </Para>
                </div>
              </Popover.Content>
            </Popover>
          }
        >
          <div className="logout-img">
            <img src="/assets/Default.png" alt="image" />
          </div>
        </OverlayTrigger>
      ))}
      {showConfirmDialog && <Prompt options={confirmDialogOptions} open={showConfirmDialog} />}
    </React.Fragment>
  );
};
export default PopOver;
